
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 17 20","stroke-opacity":"0","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M3.25 12a.75.75 0 001.5 0h-1.5zm3-3a.75.75 0 001.5 0h-1.5zm3 0a.75.75 0 001.5 0h-1.5zm3 0a.75.75 0 001.5 0h-1.5zm3 2.5a6.75 6.75 0 01-6.75 6.75v1.5a8.25 8.25 0 008.25-8.25h-1.5zM8.5 18.25a6.75 6.75 0 01-6.75-6.75H.25a8.25 8.25 0 008.25 8.25v-1.5zM1.75 11.5v-2H.25v2h1.5zm1.5-2V12h1.5V9.5h-1.5zm1.5 0v-6h-1.5v6h1.5zm1.5-6V9h1.5V3.5h-1.5zm1.5 0v-1h-1.5v1h1.5zm1.5 0V9h1.5V3.5h-1.5zm1.5 0v-1h-1.5v1h1.5zm1.5 3V9h1.5V6.5h-1.5zm1.5 0v-3h-1.5v3h1.5zM11.5 1.25A2.25 2.25 0 009.25 3.5h1.5a.75.75 0 01.75-.75v-1.5zm5.25 5.25a2.25 2.25 0 00-2.25-2.25v1.5a.75.75 0 01.75.75h1.5zM11.5 2.75a.75.75 0 01.75.75h1.5a2.25 2.25 0 00-2.25-2.25v1.5zm-3-1a.75.75 0 01.75.75h1.5A2.25 2.25 0 008.5.25v1.5zm-3 1a.75.75 0 01.75.75h1.5A2.25 2.25 0 005.5 1.25v1.5zm-.75.75a.75.75 0 01.75-.75v-1.5A2.25 2.25 0 003.25 3.5h1.5zm3-1a.75.75 0 01.75-.75V.25A2.25 2.25 0 006.25 2.5h1.5zm6.75 1.75a2.25 2.25 0 00-2.25 2.25h1.5a.75.75 0 01.75-.75v-1.5zm-12 4.5a.75.75 0 01.75.75h1.5A2.25 2.25 0 002.5 7.25v1.5zm-.75.75a.75.75 0 01.75-.75v-1.5A2.25 2.25 0 00.25 9.5h1.5zm15 2v-5h-1.5v5h1.5z"}})])
          )
        }
      }
    